import React, { useEffect } from 'react';
import { FaLock, FaInstagram, FaCode } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    });
  }, []);

  return (
    <div className="blender-wrapper" data-aos="fade-up">
      <div className="blender-container">
        
        {/* LEFT SECTION */}
        <div className="blender-left" data-aos="fade-right">
          <div className="blender-circle-bg"></div>

          <div className="blender-experience-card" data-aos="zoom-in">
            <h1>1.9+</h1>
            <p>Years Of Experience</p>
          </div>

          <div className="blender-info-box" data-aos="flip-left">
            <div className="blender-icon pink"><FaLock /></div>
            <div>
              <h2>UI/UX Design</h2>
              <p>20+ Projects</p>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="blender-right" data-aos="fade-left">
          <div className="blender-about">
            <p className="blender-subtitle">About Me</p>
            <h2 className="blender-heading">Professional Blender Arts with Blender tools</h2>
            <p className="blender-desc">
              Uniquely Creation Of Blender Works & Models, Animation And VFX Creation Using Blender Software.
            </p>
          </div>

          <div className="blender-cards">
            <div className="blender-card" data-aos="zoom-in-up" data-aos-delay="200">
              <div className="blender-card-icon pink"><FaCode /></div>
              <div>
                <h3>Software Developer</h3>
                <p>
                  Creative Software, UI/UX Designing and FullStack Developer — C#, React & MSSQL.
                </p>
              </div>
            </div>

            <div className="blender-card" data-aos="zoom-in-up" data-aos-delay="400">
              <div className="blender-card-icon pink"><FaInstagram /></div>
              <div>
                <h3>Shape Canvas</h3>
                <p>
                  All Creative Blender Arts, Models & Animation On My Instagram Page @ShapeCanvas.
                </p>
              </div>
            </div>
          </div>

          <div data-aos="fade-up" data-aos-delay="600">
            <button className="blender-button">
              View @ShapeCanvas <FaInstagram />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default App;
